import { useId, useState } from "react";
import type { ReactNode } from "react";

/** Shows on hover AND on keyboard focus, which is the part usually missed. */
export function Tooltip({ label, children }: { label: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <span className="tip-wrap"
          onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}
          onFocus={() => setOpen(true)} onBlur={() => setOpen(false)}>
      <span aria-describedby={id}>{children}</span>
      {open && <span className="tip" role="tooltip" id={id}>{label}</span>}
    </span>
  );
}
